import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import usePageMeta from "@/hooks/usePageMeta";
import { COMPANY, LEGAL_UPDATED } from "@/lib/site";

export default function LegalPageLayout({ meta, overline, title, intro, sections = [] }) {
  usePageMeta(meta);
  return (
    <div className="min-h-screen bg-surface-base text-white">
      <SiteHeader />

      <section className="relative border-b border-white/[0.06] overflow-hidden">
        <div className="absolute inset-0 grid-bg-fine opacity-60 grid-radial-mask" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12 pt-36 md:pt-44 pb-16">
          <div className="overline mb-6">{overline}</div>
          <h1 className="font-display font-medium text-[34px] sm:text-5xl tracking-tighter leading-[1.06]">{title}</h1>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[11px] text-zinc-500 uppercase tracking-[0.18em]">
            <span>Last updated · {LEGAL_UPDATED}</span>
            <span className="hidden sm:inline text-zinc-700">/</span>
            <span>{COMPANY.legalName}</span>
          </div>
          {intro && <p className="mt-8 text-sm md:text-base text-zinc-400 leading-relaxed">{intro}</p>}
        </div>
      </section>

      <section className="bg-surface-base">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <div className="space-y-12">
            {sections.map((s, i) => (
              <div key={s.h} data-testid={`legal-section-${i}`} className="scroll-mt-28" id={s.id}>
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-xs text-ai-accent">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-display font-medium text-xl md:text-2xl tracking-tight">{s.h}</h2>
                </div>
                <div className="mt-4 pl-0 sm:pl-9 space-y-4">
                  {(s.p || []).map((para, j) => (
                    <p key={j} className="text-sm text-zinc-400 leading-relaxed">{para}</p>
                  ))}
                  {s.list && (
                    <ul className="space-y-2.5">
                      {s.list.map((li) => (
                        <li key={li} className="flex gap-3 text-sm text-zinc-400 leading-relaxed">
                          <span className="mt-2 w-1 h-1 rounded-full bg-ai-accent shrink-0" />
                          <span>{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 rounded-lg border border-white/[0.08] bg-white/[0.015] p-6">
            <div className="label-xs mb-3">Contact</div>
            <p className="text-sm text-zinc-300">{COMPANY.legalName}</p>
            <p className="mt-1 text-sm text-zinc-500">Brand: {COMPANY.brand}</p>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{COMPANY.address}</p>
            <a href={`mailto:${COMPANY.email}`} className="mt-3 inline-block text-sm text-white hover:underline">{COMPANY.email}</a>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
